import React, { useEffect, useState } from "react";
import { FooterConfig, NavbarScreen, SupportScreen } from "../../components";
import { numberWithCommas, PROD_LOCATION } from "../../constants";
import moment from "moment";
function NotifyRegisterVaccineSpecial(props) {
  const [data, setData] = useState();

  useEffect(() => {
    handleInfo();
  }, []);

  const handleInfo = async () => {
    const a = await JSON.parse(localStorage.getItem("order"));
    console.log(a);
    const newValue = {
      name: a["user"]["name"] || "-",
      phone: a["user"]["phone_number"] || "-",
      email: a["user"]["email"] || "-",
      code_note: a["order"]["code_note"] || "-",
      number_register: a["order_info"]?.length || "-",
      order_info: a["order_info"] || "",
      pathogen: a["order"]["pathogen"] || "-",
      booking_date: a["order"]["booking_date_timestamp"] || "-",
      location: a["order"]["location"] || "-",
      price: a["order"]["price"],
      status: a["order"]["status"],
      payment_code: a["payment_code"]

    };

    setData(newValue);
    // console.log("new", newValue);
  };

  console.log("data", data);
  return (
    <>
      <NavbarScreen />

      <div className="NotifyRegisterVaccineSpecial container">
        <div className="row">
          <div className="content__left col-md-8 col-sm-12 p-0">
            <div className="row box">
              <div className="box__title col-12">
                Cảm ơn quý khách đã đăng ký tiêm chủng tại hệ thống tiêm chủng
                {" " + PROD_LOCATION} với các thông tin:
              </div>
              <div className="col-6 box__label ">Người đăng kí</div>
              <div className="col-6 box__content ">
                {data ? data.name : "-"}
              </div>
              <div className="col-6 box__label ">Số điện thoại</div>
              <div className="col-6 box__content ">
                {" "}
                {data ? data.phone : "-"}
              </div>
              <div className="col-6 box__label ">Email</div>
              <div className="col-6 box__content ">
                {" "}
                {data ? data.email : "-"}
              </div>
              <div className="col-6 box__label ">Mã đăng kí</div>
              <div className="col-6 box__content ">
                {" "}
                {data ? data.code_note : "-"}
              </div>
              <div className="col-6 box__label ">Số người tiêm</div>
              <div className="col-6 box__content ">
                {" "}
                {data ? data.number_register : "-"}
              </div>
              {data
                ? data.order_info.map((v, k) => {
                    return (
                      <div className="col-12 " key={k}>
                        <div className="row">
                          <div className="col-6 box__label   ">
                            Người tiêm {k + 1}
                          </div>
                          <div className="col-6 box__content  ">
                            {v.name || "-"}
                          </div>
                        </div>
                      </div>
                    );
                  })
                : "-"}

              <div className="col-6 box__label ">Ngày đăng ký </div>
              <div className="col-6 box__content ">
                {" "}
                {data
                  ? moment.unix(data.booking_date).format("DD/MM/YYYY")
                  : "-"}
              </div>

              <div className="col-6 box__label ">Vaccine đăng kí</div>
              <div className="col-6 box__content ">
                {data ? data.pathogen : "-"}
              </div>
              <div className="col-6 box__label ">Mã thanh toán </div>
              <div className="col-6 box__content ">
                {data ? data.payment_code : "-"}
              </div>

              <div className="col-6 box__label ">Tổng giá trị thanh toán </div>
              <div className="col-6 box__content ">
                {data ? data.price : "VNĐ"}
              </div>

              <div className="col-6 box__label ">Số tiền thanh toán trước </div>
              <div className="col-6 box__content ">
                {data ? data.price : "VNĐ"}
              </div>

              <div className="col-6 box__label ">
                Trạng thái thanh toàn đặt cọc
              </div>
              <div className="col-6 box__content ">Chưa thanh toán</div>
              <div className="col-6 box__label ">Cơ sở phòng tiêm đăng ký</div>
              <div className="col-6 box__content ">
                {data ? data.location.name : "-"}
              </div>

              <div className="col-6 box__label ">Địa chỉ</div>
              <div className="col-6 box__content ">
                {data ? data.location.description : ""}
              </div>
              <div className="col-6 box__label ">Điện thoại</div>
              <div className="col-6 box__content ">
                {data ? data.location.phone_number : ""}
              </div>
              <div className="col-6 box__label "> Email</div>
              <div className="col-6 box__content ">
                {data ? data.location.email : ""}
              </div>
              <div className="col-12 notify-first">
                <span className="bold">Để hoàn tất thủ tục đăng kí </span> quy
                khách vui lòng thanh toán số tiền {data ? data.price : ` VNĐ `}
                &nbsp; vào tài khoản : <br />- Ngân hàng Techcombank chi nhánh
                Bắc Từ Liêm Hà Nội <br /> - Số tài khoản : xxxxxxxx <br />- Nội
                dung chuyển khoản : <b> ADMS231231221-090342006 </b>
                <br />
                Cán bộ cơ sở tiêm chủng {" " + PROD_LOCATION} sẽ liên hệ với quý
                khách qua email để xác nhận lịch tiêm qua điện thoại và email
                sau khi quý khách hoàn tất thủ tục đặt cọc đăng kí tiêm
              </div>
              <div className="col-12 notify-second">
                Trường hợp Quý khách có những vướng mắc , có thể xem mục{" "}
                <a href="http://www.safpo.com/">câu hỏi thường</a> gặp. Quý
                khách cần được hỗ trợ ngay? Chỉ cần email{" "}
                <a href="mailto:support-safpo@amv.vn">support-safpo@amv.vn</a>,
                hoặc gọi số điện thoại <a href="">1900 2071</a> (Từ 8h - 22h
                (Thứ 2 - Chủ Nhật). Đội ngũ SAFPO luôn sẵn sàng hỗ trợ Quý khách
                bất kì lúc nào.Để chắc chắn luôn nhận được email thông báo, xác
                nhận đăng ký từ safpo.vn, Quý khách vui lòng thêm địa chỉ{" "}
                <a href="mailto:support-safpo@amv.vn">support-safpo@amv.vn</a>
                vào số địa chỉ (Address Book, Contacts) của hộp email.
                <span>
                  Một lần nữa {" " + PROD_LOCATION} xin cảm ơn quý khách đã tin
                  tưởng và rất hân hạnh được phục vụ Quý khách.
                </span>
              </div>
            </div>
          </div>
          <div className="content__right col-md-4 col-sm-12 pr-0">
            <SupportScreen />
          </div>
        </div>
      </div>

      <FooterConfig />
    </>
  );
}

export default NotifyRegisterVaccineSpecial;
